<template>
  <div class="health-detail">
<!--    <van-nav-bar fixed left-arrow title="文章详情页" :border="false" @click-left="routerBack" />-->
    <div class="header">
      <div class="main">
        <p>全溯应用市场</p>
        <van-nav-bar left-arrow title="文章详情页" :border="false" @click-left="routerBack" />
      </div>
    </div>
    <van-pull-refresh class="content" v-model="isLoading" @refresh="onRefresh">
      <div class="detail_date" >
        <p>{{datas.operationTime}}</p>
      </div>
      <div class="detail_cont" v-html="datas.content"></div>
      <p class="detail_bottom">
        <span>作者 {{datas.operationName}}</span><span>阅读 {{datas.readingNumber}}</span>
      </p>
    </van-pull-refresh>


  </div>
</template>
<script>

import {healthyDetails} from "api/home";

export default {
  components: {

  },
  data() {
    return {
      isLoading: false,
      id: '',
      datas: {}

    }
  },
  activated() {

  },
  created() {
    this.id = this.$route.query.id;
    this.getDetails();
  },
  methods: {
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false;
        this.getDetails();
      }, 1000);
    },
    routerBack() {
      this.$router.back()
    },
    onSearch() {

    },
    onChange(value) {
      // console.log(value)
      // this.$toast('提示文案');
    },
    getDetails() {
      healthyDetails({id: this.id}).then(res => {
        if (res.code == 0) {
          this.datas = res.data;
        }
      })
    }

  }
}
</script>
<style scoped lang="less" >
.header {
  width: 100%;
  box-sizing: border-box;
  height: 97px;
  padding: 5px 0px;
  background: url(../../../assets/imgs/top-bj.png) no-repeat center/100% 100%;
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  .main {
    p {
      font-size: 15px;
      font-weight: bold;
      color: #fff;
      text-align: center;
      margin-bottom: 15px;
    }
    & ::v-deep {
      .van-nav-bar {
        background-color: transparent;
      }
      .van-nav-bar__title {
        color: #ffffff !important;
      }
      .van-nav-bar .van-icon {
        color: #ffffff;
      }
    }

  }



}
//& ::v-deep {
//  .van-nav-bar {
//    background-image: url(../../../assets/imgs/top-bj.png);
//    background-repeat: no-repeat;
//    background-position: center/100% 100%;
//  }
//  .van-nav-bar {
//    background-color: transparent;
//  }
//  .van-nav-bar__title {
//    color: #ffffff !important;
//  }
//  .van-nav-bar .van-icon {
//    color: #ffffff;
//  }
//}


.content {
  padding: 13px;
  .detail_date {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;

  }
  .detail_cont {
    width: 100%;
    box-sizing: border-box;
    padding-top: 20px;
  }
  .detail_bottom {
    width: 100%;
    box-sizing: border-box;
    //text-align: right;
    padding-top: 20px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 12px;
    color: #CCCCCC;
    span {
      margin-right: 30px;
    }
  }




}

</style>